"use client";

import { MotionConfig } from "framer-motion";
import useGeneralStore from "@/store/General/useGeneralStore";
import { parseJsonBody } from "@/lib/general.utils";
import { useTranslation } from "next-i18next";
import HeroSliderSection from "./sections/HeroSliderSection";
import MissionVisionSection from "./sections/MissionVisionSection";
import DonationSection from "./sections/DonationSection";
import ServicesSection from "./sections/ServicesSection";
import AchievementsSection from "./sections/AchievementsSection";
import LatestNewsSection from "./sections/LatestNewsSection";
import BoardOfTrusteesSection from "./sections/BoardOfTrusteesSection";
import PartnersSection from "./sections/PartnersSection";

const HomeComponent = () => {
  const { HomeComponent } = useGeneralStore();
  const { i18n } = useTranslation();
  const home = parseJsonBody(HomeComponent?.jsonBody);
  if (!HomeComponent) return null;
  return (
    <MotionConfig
      reducedMotion="user"
      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
    >
      <div
        dir={i18n.dir()}
        lang={i18n.language}
        className="h-full flex flex-col w-full overflow-x-hidden"
      >
        {home.heroSlider && <HeroSliderSection {...home.heroSlider} />}
        {home.mission && home.vision && home.methodology && (
          <MissionVisionSection
            mission={home.mission}
            vision={home.vision}
            methodology={home.methodology}
          />
        )}
        {home.donation && <DonationSection donation={home.donation} />}
        {home.services && <ServicesSection services={home.services} />}
        {home.achievements && (
          <AchievementsSection achievements={home.achievements} />
        )}
        {home.latestNews && <LatestNewsSection latestNews={home.latestNews} />}
        {home.boardOfTrustees && (
          <BoardOfTrusteesSection boardOfTrustees={home.boardOfTrustees} />
        )}
        {home.partners && <PartnersSection partners={home.partners} />}
      </div>
    </MotionConfig>
  );
};
export default HomeComponent;
